__turbopack_context__.v({
  "actions": "sports-site-chrome-module__A7f62a__actions",
  "announcement": "sports-site-chrome-module__A7f62a__announcement",
  "brand": "sports-site-chrome-module__A7f62a__brand",
  "childLinks": "sports-site-chrome-module__A7f62a__childLinks",
  "dropPanel": "sports-site-chrome-module__A7f62a__dropPanel",
  "footer": "sports-site-chrome-module__A7f62a__footer",
  "footerBottom": "sports-site-chrome-module__A7f62a__footerBottom",
  "footerBrand": "sports-site-chrome-module__A7f62a__footerBrand",
  "footerGroup": "sports-site-chrome-module__A7f62a__footerGroup",
  "footerGroups": "sports-site-chrome-module__A7f62a__footerGroups",
  "footerHeading": "sports-site-chrome-module__A7f62a__footerHeading",
  "footerInner": "sports-site-chrome-module__A7f62a__footerInner",
  "groupOverview": "sports-site-chrome-module__A7f62a__groupOverview",
  "groupTrigger": "sports-site-chrome-module__A7f62a__groupTrigger",
  "header": "sports-site-chrome-module__A7f62a__header",
  "headerRow": "sports-site-chrome-module__A7f62a__headerRow",
  "logo": "sports-site-chrome-module__A7f62a__logo",
  "menuToggle": "sports-site-chrome-module__A7f62a__menuToggle",
  "mobilePrimaryAction": "sports-site-chrome-module__A7f62a__mobilePrimaryAction",
  "navItem": "sports-site-chrome-module__A7f62a__navItem",
  "navLink": "sports-site-chrome-module__A7f62a__navLink",
  "navigation": "sports-site-chrome-module__A7f62a__navigation",
  "primaryAction": "sports-site-chrome-module__A7f62a__primaryAction",
});
